import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const guru = defineConnector({
  identifier: "guru",
  name: "Guru",
  tagLine: "Team knowledge management",
  logo,
  protocol: "http",
  tags: ["documents"],
  defaultUrlPattern: () => "https://api\\.getguru\\.com/api/v1/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Find your Guru API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Guru](https://app.getguru.com/) and click your profile icon → **Settings → API Access**. Generate an API token. Use your email as the username and the API token as the password.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content: "Enter the API credentials from your Guru account settings.",
        },
        {
          kind: "input",
          label: "User/Collection ID",
          required: true,
          target: { kind: "secrets", field: "username" },
          helperText: "The user or collection ID of your Guru account",
        },
        {
          kind: "input",
          label: "User/Collection Token",
          required: true,
          target: { kind: "secrets", field: "password" },
          placeholder: "123e4567-e89b-12d3-a456-426614174000",
          helperText: "The user or collection token of your Guru account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.getguru.com/api/v1/whoami",
  },
});
